import { getTokenDefinition, } from "@bracket/chainography";
import { contract, getTokenDefinition as getTokenDefinitionNext, multiCaller, } from "@bracket/chainography/contracts";
import type { TokenIdentifier, } from "@bracket/types";
import { deepAssign, } from "@utils";
import { wagmiConfig as config, } from "@wagmiconfig";
import { cache, initialTokenCache, } from "./cache";
import { getAggregateError, } from "@bracket/catch";


/**
 * Gets the conversion rate for a token FOR ETH ONLY - "THIS IS A ONCE OFF, WE WILL NEVER NEED IT AGAIN."
 * @todo currently this requires the full vault object so as to determine the denominating token.. Not ideal.
 * 
 * @param {object} params - The parameters object
 * @param {TokenIdentifier} params.token - The token identifier to get the rate for
 * @param {LoadedVault} params.vault - The vault to get the rate for
 * @returns {Promise<number>} The conversion rate in wei
 */
export const convRate = async ({
	token,
}: {
	token: TokenIdentifier;
}): Promise<number> => {
	const now = Date.now();
	const { address, symbol, } = getTokenDefinition(token);
	if(symbol === "ETH" || symbol === "WETH") {
		return 1;
	}
	cache.tokens[symbol] = cache.tokens[symbol] || deepAssign({}, initialTokenCache);
	const { time, value, since, } = cache.tokens[symbol].conv_rate;
	if(since > now - time) {
		return value;
	}


	const [ [ rate, ], error, ] = await multiCaller<[bigint]>(config, [
		(	
			symbol === "BRKTETH" ? contract("BrktETH", "getBracketRate") :
			symbol === "USDC" ? contract("Pricing", "getLatestPrice", getTokenDefinitionNext("ETH_USD").address) :
			contract("BracketOracle", "getRate", address)
		)
	]);

	if(error) {

		throw getAggregateError(error, `cache item "convRate" failed for token ${symbol}`);
	}

	const next = Number(rate) / (10**18)
	cache.tokens[symbol].conv_rate.since = Date.now();
	cache.tokens[symbol].conv_rate.value = next;
	return next;
}
